module.exports = "/_next/static/images/DefaultImageBerthingManagement-670aa0da0aeedd144dcc6bc8d97aebce.png";